import { render } from "./CasterStatsDynamicsChartPage.vue?vue&type=template&id=22155bc8"
import script from "./CasterStatsDynamicsChartPage.vue?vue&type=script&lang=js"
export * from "./CasterStatsDynamicsChartPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__